<template>
    <div id="setup-tab-evo-container">
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('companySetup.tabPreferences.passwordDays')"
                    v-bind:Name="'PasswordDays'"
                    v-bind:TypeProp="'number'"
                    v-model="editableItem.passwordDays"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Min="'0'"
                    v-bind:StepProp="'1'"
                    v-bind:Max="'10'"
                    v-bind:Id="'input_passwordDays'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('companySetup.tabPreferences.sessionTimeout')"
                    v-bind:Name="'SessionTimeout'"
                    v-bind:TypeProp="'number'"
                    v-model="editableItem.sessionTimeout"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Min="'0'"
                    v-bind:StepProp="'1'"
                    v-bind:Max="'10'"
                    v-bind:Id="'input_sessionTimeout'"
                />
            </b-col>       
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('UserPreferences.Dl')"
                    v-bind:Options="languageOptions"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.language"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="value => changeLan(value)"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('companySetup.tabPreferences.dateDisplayFormat')"
                    v-bind:Options="dateFormatOptions"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.dateDisplayFormat"
                    v-bind:Multiple="false"
                    :IsDisabled="isReadOnly"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.enforcePasswordPolicy')"
                    v-bind:Name="'checkbox-policy'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.enforcePasswordPolicy"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.resetExpiration')"
                    v-bind:Name="'checkbox-used'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.resetExpiration"
                    v-on:change="onResetExpirationChange"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.terminateWrongSignInUser')"
                    v-bind:Name="'checkbox-terminate'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.terminateWrongSignInUser"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.passwordEncryptedPBKDF2')"
                    v-bind:Name="'checkbox-pbkdf2'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.passwordEncryptedPBKDF2"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdRadioGroup
                    v-bind:Label="$t('companySetup.tabPreferences.unitSystem')"
                    v-model="editableItem.unitSystem"
                    v-bind:Options="unitoptions"
                    v-bind:Name="'UnitSystem'"
                    v-bind:isReadOnly="this.isReadOnly"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.ignoreReadOnly')"
                    v-bind:Name="'checkbox-ignore-readonly'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.ignoreReadOnly"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.useBillingEntity')"
                    v-bind:Name="'checkbox-use-billing-entity'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.useBillingEntity"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.maskSsn')"
                    v-bind:Name="'checkbox-mask-ssn'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.maskSsn"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>         
        </b-row>
        <MdTitle
            v-bind:Text="$t('companySetup.tabPreferences.passwordPolicy.title')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.enforcePasswordPolicy')"
                    v-bind:Name="'checkbox-policy'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.enforcePasswordPolicy"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
        </b-row>
        <div class="col-md-4 grid-margin stretch-card">
            <div class="card activeCard">
                <div class="card-body forceLTR">
                    <div class="d-flex align-items-start justify-content-between pointer forceLTR">
                        <h6 class="card-title flex-grow lower-line text-truncate">
                            {{ $t('companySetup.tabPreferences.passwordPolicy.details') }}
                        </h6>
                    </div>

                    <div class="text-muted">
                        <ul>
                            <li
                                v-for="(item, index) in passwordRequirements"
                                :key="`passwordRequirement-${index}`"
                            >
                                {{ $t(item.text) }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <MdTitle
            v-bind:Text="$t('companySetup.tabPreferences.actDirectoryAuth')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.useActDirAuth')"
                    v-bind:Name="'checkbox-use-active-directory-auth'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.useActiveDirectoryAuth"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.syncUserGroupsAd')"
                    v-bind:Name="'checkbox-sync-user-groups-ad'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.syncUserGroupsAd"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('companySetup.tabPreferences.adServerIp')"
                    v-bind:Name="'AdServerIp'"
                    v-bind:TypeProp="'text'"
                    v-model="editableItem.activeDirectoryHost"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_adServerIp'"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('companySetup.tabPreferences.adDomain')"
                    v-bind:Name="'activeDirectoryDomain'"
                    v-bind:TypeProp="'text'"
                    v-model="editableItem.activeDirectoryDomain"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_activeDirectoryDomain'"
                />
            </b-col>                
        </b-row>
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('companySetup.tabPreferences.adBaseDN')"
                    v-bind:Name="'activeDirectoryDnbase'"
                    v-bind:TypeProp="'text'"
                    v-model="editableItem.activeDirectoryDnbase"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_activeDirectoryDnbase'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('companySetup.tabPreferences.defUserId')"
                    v-bind:Options="defaultuserTemplateList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="editableItem.defaultUserIdAdTemplate"
                    :IsDisabled="isReadOnly"
                    :Input="ChangeDropDowndefaultUserId"
                />
            </b-col>                
        </b-row>

         <MdTitle
            v-bind:Text="$t('companySetup.tabPreferences.zipCodeAPI')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('companySetup.tabPreferences.autoPopulate')"
                    v-bind:Name="'checkbox-use-zip-code-api'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.useZipCodeApi"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
           
            <b-col md="3" lg="3" sm="12" v-if="editableItem.useZipCodeApi">
                <MdEdit
                    v-bind:Label="$t('URL')"
                    v-bind:Name="'ZipCodeApiurl'"
                    v-bind:TypeProp="'text'"
                    v-model="editableItem.zipCodeApiurl"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_zipCodeApiurl'"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12" v-if="editableItem.useZipCodeApi">
                <MdEdit
                    v-bind:Label="$t('companySetup.tabPreferences.apiUser')"
                    v-bind:Name="'ZipCodeApiuser'"
                    v-bind:TypeProp="'text'"
                    v-model="editableItem.zipCodeApiuser"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_zipCodeApiuser'"
                />
            </b-col>                
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'TabPreference',
    props: {
        value: {
            Type: Object,
            default: null
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        },
        defaultuserTemplateList: {
            Type: Array,
            default: () => []
        }
    },
    data() {
        const defaultItemData = {
            passwordDays: null,
            language: '',
            paymentDueDate: null,
            sessionTimeout: null,
            concurrentLimit: null,
            ignoreReadOnly: '',
            useActiveDirectoryAuth: '',
            activeDirectoryDomain: '',
            activeDirectoryHost: '',
            activeDirectoryDnbase: '',
            defaultUserIdAdTemplate: [],
            syncUserGroupsAd: false,
            useBillingEntity: false,
            maskSsn: false,
            useZipCodeApi: false,
            zipCodeApiurl: '',
            zipCodeApiuser: '',
            unitSystem: '',
            passwordEncryptedPBKDF2:false,
            dateDisplayFormat: '',
            enforcePasswordPolicy: false,
            terminateWrongSignInUser: false,
            resetExpiration: false
        };
        return {
            editableItem: this.value || defaultItemData,
            defaultItemData: defaultItemData,
            unitoptions: [
                { text: this.$t('US'), value: 'U' },
                { text: this.$t('Metric'), value: 'M' }
            ],
            languageOptions: [
                { text: this.$t('EN'), value: 'EN' },
                { text: this.$t('ES'), value: 'ES' },
                { text: this.$t('AR'), value: 'AR' }
            ],
             dateFormatOptions: [
                { text: 'MM/dd/yyyy', value: 'MM/dd/yyyy' },
                { text: 'dd/MM/yyyy', value: 'dd/MM/yyyy' }
            ], 
            passwordRequirements: [
                { text: 'companySetup.tabPreferences.passwordPolicy.minLength' },
                { text: 'companySetup.tabPreferences.passwordPolicy.uppercase' },
                { text: 'companySetup.tabPreferences.passwordPolicy.lowercase' },
                { text: 'companySetup.tabPreferences.passwordPolicy.number' },
                { text: 'companySetup.tabPreferences.passwordPolicy.specialCharacter' }
            ]
        };
    },
    watch: {
        value(newVal) {
             this.$nextTick(() => {
                 this.editableItem = newVal || this.defaultItemData;
            });
        },
    },
    methods: {
        emitChanged() {
            this.$emit('input', this.editableItem);
        },

        changeLan(value) {
            this.editableItem.language = value;
            this.emitChanged();
        },

        onResetExpirationChange() {
            this.$emit('reset-expiration-change', this.editableItem);
        },

        ChangeDropDowndefaultUserId(item) {
            this.editableItem.defaultUserIdAdTemplate = item ? item.code : null;
        },
    }
};
</script>
